import * as z from "zod";

export const stationSchema = z.object({
  id: z.number(),
  name: z.string(),
  lat: z.number().optional(),
  lon: z.number().optional(),
});

export type Station = z.infer<typeof stationSchema>;

export const stationsSchema = z.array(stationSchema);
